import React from "react";
import { Route, Routes, Outlet } from "react-router-dom";
import LoginComponent from '../pages/login';
import AdminLayout from '../layout/AdminLayout';
import AdminRoutes from './AdminRoutes';
import DealerRoutes from './DealerRoutes';
import { AuthProvider } from '../pages/login/AuthContext';
import RoleGuard from "../pages/login/RoleGuard";
import Unauthorized from "../pages/login/Unauthorized";

const Router = () => {
    
    return (
        // <AuthProvider>
            <Routes>
                <Route path="/" element={<LoginComponent />}></Route>
                <Route path="/login" element={<LoginComponent />} />
                <Route path="/unauthorized" element={<Unauthorized/>} />
                <Route path="" element={<Outlet />} >
                        {
                            AdminRoutes.map((element) => {
                                return (
                                    <Route key={element} path={element.path} element={
                                        <RoleGuard roles={100}>
                                            <AdminLayout component={element.component} />
                                        </RoleGuard>
                                    } />
                                );
                            })
                        }
                        {
                            DealerRoutes.map((element) => {
                                return (
                                    <Route key={element} path={element.path} element={
                                        <RoleGuard roles={1000}>
                                            <AdminLayout component={element.component} />
                                        </RoleGuard>
                                    } />
                                );
                            })
                        }
                </Route>
                <Route exact path="*" element={<Unauthorized/>} />
            </Routes>
        // </AuthProvider>
    );
}

export default React.memo(Router);